import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthenticationService } from 'src/app/shared/services';
import { ScreenSizeService } from 'src/app/shared/services/screen-size.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { Location } from '@angular/common';
import { CreditsService } from 'src/app/shared/services/credits.service';
import { commonService } from 'src/app/shared/services/common.service';
import { WalletService } from 'src/app/shared/services/walletService.service';
import { OrgPlanService } from 'src/app/shared/services/org-plan.service';
@Component({
  selector: 'app-head-toolbar',
  templateUrl: './head-toolbar.component.html',
  styleUrls: ['./head-toolbar.component.css'],
})
export class HeadToolbarComponent implements OnInit {
  currentDateTime: Date = new Date();
  isFullScreen: boolean = false;
  hover: any;

  isDarkTheme: any;
  themeButtonIcon: string = 'pi pi-moon';
  isMobileScreen: boolean = false;
  items: MenuItem[] | undefined;
  roleName: any;
  userId: any;
  is_staff: any;
  // role: string = localStorage.getItem('role') || '';
  credits: any;
  numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  animatedDigits: number[] = [];
  profileImage: string = '';
  previousValue = 0;
  isFirstLoad = true;
  role = '';
  isLight = false;

  /** Static for now — swap for the notifications API unread count. */
  notificationCount = 2;

  /** Drives the notification bell in the header. */
  isCandidate = false;
  // Update your configuration arrays to keep navigation clean
  menuConfig: any = {
    org_admin: ['user-management', 'job-posting'],
    hr_head: ['hr-dashboard', 'user-management', 'job-posting', 'org-lms'],
    tl: ['tl-dashboard', 'job-posting'],
    recruiter: ['recruiter-dashboard', 'job-posting'],
    reporting_manager: ['reporting-manager-dashboard', 'job-posting', 'team-lms'],
    // Grouped under Practice tab now, so we remove independent 'Daily_challenge' from root
    cnd: ['resume-builder', 'Practice', 'Assessments', 'leaderboard', 'candidate-lms'],
    // A candidate who signed in through an organization's job post — see
    // isOrgScopedCandidate below. They are here to sit an exam, so that is
    // the only module they get.
    cnd_org: ['exam'],
    freelancer: ['candidate-dashboard', 'exam', 'Practice', 'candidate-lms'],
    system_admin: ['system-admin-dashboard','org-management','contest-management','lms','configurator'],
    employee: ['employee-lms'],
  };

  allMenus: any = {
    dashboard: {
      label: 'Dashboard',
      icon: 'pi pi-home',
      route: '/candidate-dashboard',
    },
    'user-management': {
      label: 'User Management',
      icon: 'pi pi-users',
      route: '/user-management',
    },
    'org-management': {
      label: 'Org Management',
      icon: 'pi pi-building',
      route: '/org-management',
    },
    'job-posting': {
      label: 'Job Posting',
      icon: 'pi pi-briefcase',
      route: '/job-posting',
    },
    'cnd-jobs': {
      label: 'Applied Jobs',
      icon: 'pi pi-briefcase',
      route: '/cnd-jobs',
    },
    exam: {
      label: 'Exam',
      icon: 'pi pi-book',
      route: '/exam',
    },
    hiring: {
      label: 'Hiring',
      icon: 'pi pi-user-plus',
      route: '/hiring',
    },
    'system-admin-dashboard': {
      label: 'Dashboard',
      icon: 'pi pi-th-large',
      route: '/system-admin-dashboard',
    },
    lms: {
      label: 'LMS',
      icon: 'pi pi-compass',
      route: '/lms',
    },
    'org-lms': {
      label: 'LMS',
      icon: 'pi pi-compass',
      children: [
        {
          label: 'Learning Portal',
          icon: 'pi pi-th-large',
          route: '/lms/org-portal',
        },
        {
          label: 'Enrolled Staff',
          icon: 'pi pi-users',
          route: '/lms/org-portal/staff',
        },
        {
          label: 'Quiz Studio',
          icon: 'pi pi-sparkles',
          route: '/lms/org-portal/quiz-studio',
        },
        {
          label: 'Progress Monitoring',
          icon: 'pi pi-chart-line',
          route: '/lms/org-portal/progress',
        },
      ],
    },
    'team-lms': {
      label: 'LMS',
      icon: 'pi pi-compass',
      children: [
        {
          label: 'Learning Portal',
          icon: 'pi pi-th-large',
          route: '/lms/team-portal',
        },
        {
          label: 'Quiz Studio',
          icon: 'pi pi-sparkles',
          route: '/lms/team-portal/quiz-studio',
        },
        {
          label: 'Progress Monitoring',
          icon: 'pi pi-chart-line',
          route: '/lms/team-portal/progress',
        },
      ],
    },
    'candidate-lms': {
      label: 'My Learning',
      icon: 'pi pi-book',
      route: '/lms/my-learning',
    },
    'employee-lms': {
      label: 'My Learning',
      icon: 'pi pi-book',
      route: '/lms/employee-learning',
    },
    'candidate-dashboard': {
      label: 'Dashboard',
      icon: 'pi pi-home',
      route: '/candidate-assesment/start-assesment',
    },
    'employee-dashboard': {
      label: 'Dashboard',
      icon: 'pi pi-th-large',
      route: '/employee-dashboard',
    },
    'recruiter-dashboard': {
      label: 'Dashboard',
      icon: 'pi pi-th-large',
      route: '/recruiter-dashboard',
    },
    'hr-dashboard': {
      label: 'Dashboard',
      icon: 'pi pi-th-large',
      route: '/hr-dashboard',
    },
    'tl-dashboard': {
      label: 'Dashboard',
      icon: 'pi pi-th-large',
      route: '/tl-dashboard',
    },
    'reporting-manager-dashboard': {
      label: 'Dashboard',
      icon: 'pi pi-th-large',
      route: '/reporting-manager-dashboard',
    },
    // 'user-management': {
    //   label: 'User Management',
    //   icon: 'pi pi-cog',
    //   route: '/user-management',
    // },
    'resume-builder': {
      label: 'CV Builder',
      icon: 'pi pi-file-edit',
      route: '/resume-builder',
    },
    contest: {
      label: 'Contest',
      icon: 'pi pi-file-edit',
      route: '/contest-arena',
    },

    // Beautiful nested navigation group for all testing items
    Assessments: {
      label: 'Assessments',
      icon: 'pi pi-id-card',
      children: [
        {
          label: 'Exam',
          icon: 'pi pi-book',
          route: '/exam',
        },
        {
          label: 'Contest Arena',
          icon: 'pi pi-shield',
          route: '/contest-arena',
        },
        {
          label: 'AI Interview',
          icon: 'pi pi-video',
          route: '/ai-interview',
        },
      ],
    },

    // Custom Modern Nested Navigation Grouping
    Practice: {
      label: 'Practice',
      icon: 'pi pi-sparkles',
      children: [
        {
          label: 'Coding',
          icon: 'pi pi-code',
          route: '/practice',
          queryParams: { mode: 'coding' },
        },
        {
          label: 'MCQs',
          icon: 'pi pi-list',
          route: '/practice',
          queryParams: { mode: 'mcq' },
        },
        {
          label: 'Daily Challenge',
          icon: 'pi pi-bolt',
          route: '/daily-challenge',
        },
        {
          label: 'Challenge Packs',
          icon: 'pi pi-box',
          route: '/challenge-packs',
        },
      ],
    },

    'ai-interview': {
      label: 'AI Interview',
      icon: 'pi pi-video',
      route: '/ai-interview',
    },
    leaderboard: {
      label: 'Leaderboard',
      icon: 'pi pi-trophy',
      route: '/leaderboard',
    },
    'contest-management': {
      label: 'Contest Management',
      icon: 'pi pi-trophy',
      route: '/contest-management',
    },
    'configurator': {
      label: 'Configurator',
      icon: 'pi pi-sliders-h',
      route: '/configurator',
    },
  };
  visibleMenus: any[] = [];
  userName: string = '';
  isScrolled: boolean = false;
  @HostListener('window:scroll')
  onScroll() {
    this.isScrolled = window.scrollY > 10;
  }

  walletDrawerVisible: boolean = false;

  totalCredits: number = 0;

  blueCredits: number = 0;
  greenCredits: number = 0;
  goldCredits: number = 0;
  animateWallet = false;
  showReward = false;
  rewardText = '';

  isInitialWalletLoad = true;
  coins = Array(5).fill(0);

  showCoins = false;

  /** Free-trial countdown chip next to the wallet chip — driven by the
   *  `organization_plan` block from the login response (OrgPlanService). */
  orgPlan: any = null;
  daysRemainingInTrial: number | null = null;
  trialUrgency: 'calm' | 'amber' | 'red' = 'calm';
  showTrialCountdown = false;

  constructor(
    private themeService: ThemeService,
    private screenSizeService: ScreenSizeService,
    private authentication: AuthenticationService,
    private router: Router,
    private location: Location,
    private creditService: CreditsService,
    private common: commonService,
    private walletService: WalletService,
    private orgPlanService: OrgPlanService,
  ) {}

  ngOnInit(): void {
    // this.role = this.authentication.currentUserValue.role;
    // this.is_staff = localStorage.getItem('is_staff') === 'true';
    // const user = JSON.parse(localStorage.getItem('user') || '{}');

    const user = JSON.parse(localStorage.getItem('user') || '{}');

    this.role = (user.role_name || '').toLowerCase().replace(/\s/g, '_');

    this.userName = user?.username || '';
    this.roleName = user?.role_name || '';

    // Older sessions signed in before `user` was persisted, so fall back to
    // the plain `role` key that every login path writes.
    const fallbackRole = (localStorage.getItem('role') || '')
      .toLowerCase()
      .replace(/\s/g, '_');

    this.role = this.role || fallbackRole;

    this.isCandidate = ['cnd', 'candidate', 'freelancer'].includes(this.role);

    this.orgPlanService.orgPlan$.subscribe((plan) => {
      this.orgPlan = plan;
      this.updateTrialCountdown();
    });

    this.generateMenu();

    this.updateDateTime();

    this.screenSizeService.isMobileScreen$.subscribe((isMobile) => {
      this.isMobileScreen = isMobile;
    });

    const storedTheme = localStorage.getItem('app-theme');

    if (storedTheme) {
      this.themeService.toggleAppTheme(storedTheme);
      this.isDarkTheme = storedTheme === 'bootstrap4-dark-blue';
    } else {
      this.isDarkTheme = false;
      this.themeService.toggleAppTheme('bootstrap4-light-blue');
    }

    document.addEventListener(
      'fullscreenchange',
      this.handleFullScreenChange.bind(this),
    );
    document.addEventListener(
      'webkitfullscreenchange',
      this.handleFullScreenChange.bind(this),
    );
    document.addEventListener(
      'mozfullscreenchange',
      this.handleFullScreenChange.bind(this),
    );
    document.addEventListener(
      'MSFullscreenChange',
      this.handleFullScreenChange.bind(this),
    );
    setInterval(() => this.updateDateTime(), 1000);
    this.walletService.wallet$.subscribe((wallet: any) => {
      if (!wallet) return;

      const newBlue = wallet.blue_credits || 0;
      const newGreen = wallet.green_credits || 0;
      const newGold = wallet.gold_points || 0;

      const newTotal = newBlue + newGreen + newGold;

      // first time page load
      if (this.isInitialWalletLoad) {
        this.blueCredits = newBlue;
        this.greenCredits = newGreen;
        this.goldCredits = newGold;
        this.totalCredits = newTotal;

        this.isInitialWalletLoad = false;

        return;
      }

      const diff = newTotal - this.totalCredits;

      if (diff !== 0) {
        this.playRewardAnimation(diff, newTotal);
      }

      this.blueCredits = newBlue;
      this.greenCredits = newGreen;
      this.goldCredits = newGold;
    });

    this.walletService.loadWallet();

    // Refreshes organization_plan from the backend rather than relying only
    // on the login-time snapshot, so a trial that ends while the user is
    // still logged in (no re-login in between) flips the trial chip and
    // "Free during trial" tags to FREE_TIER_ENDED without needing a log
    // out/in.
    this.orgPlanService.loadOrgPlan();

    // View Profile used to be hidden for the internal roles because they
    // had nowhere to go — /candidate-profile is a candidate screen. They
    // now have /employee-profile, so everyone gets the item and
    // updateProfile() sends each role to the right page.
    this.items = [
      {
        label: 'Profile',
        items: [
          // An org-scoped candidate has no profile page to go to — they
          // were invited to sit one exam — so the item is dropped rather
          // than pointing at a screen that isn't theirs. Reset Password
          // and Sign-out stay, or they'd have no way out.
          ...(this.isOrgScopedCandidate || this.role === 'system_admin'
            ? []
            : [
                {
                  label: 'View Profile',
                  icon: 'pi pi-user',
                  command: () => this.updateProfile(),
                },
              ]),

          ...(this.hasEmployeeProfile
            ? [
                {
                  label: 'Organization Tree',
                  icon: 'pi pi-sitemap',
                  command: () => this.goToOrganizationTree(),
                },
              ]
            : []),

          {
            label: 'Reset Password',
            icon: 'pi pi-lock',
            command: () => this.resetPassword(),
          },

          {
            label: 'Sign-out',
            icon: 'pi pi-sign-out',
            command: () => this.logout(),
          },
        ],
      },
    ];

    // this.creditService.credits$.subscribe((credits) => {
    //   this.credits = credits;
    // });

    // this.creditService.credits$.subscribe((credits) => {
    //   if (!credits) return;

    //   const newValue = credits.remaining_credits || 0;

    //   // First load → no animation
    //   if (this.isFirstLoad) {
    //     this.animatedDigits = this.toDigits(newValue);
    //     this.previousValue = newValue;
    //     this.isFirstLoad = false;
    //   }
    //   // Only animate if value changed
    //   else if (newValue !== this.previousValue) {
    //     this.animateCredits(this.previousValue, newValue);
    //     this.previousValue = newValue;
    //   }

    //   this.credits = credits;
    // });

    // // Load initial credits
    // this.creditService.loadCredits();

    const savedTheme = localStorage.getItem('theme');

    if (savedTheme === 'light') {
      this.isLight = true;
      document.body.classList.add('light-theme');
    }
  }

  // loadWallet(): void {
  //   this.common.get('/wallets/wallet/').subscribe({
  //     next: (res: any) => {
  //       console.log('Wallet:', res);

  //       this.blueCredits = res?.blue_credits || 0;
  //       this.greenCredits = res?.green_credits || 0;
  //       this.goldCredits = res?.gold_credits || 0;

  //       this.totalCredits =
  //         this.blueCredits + this.greenCredits + this.goldCredits;
  //     },
  //     error: (err: any) => {
  //       console.error('Failed to load wallet', err);
  //     },
  //   });
  // }

  /**
   * Recomputes the free-trial countdown chip from `organization_plan`.
   * Hidden once the trial has ended — the org's `free_tier` flag flips to
   * false server-side at that point (organization_plan.status becomes
   * 'FREE_TIER_ENDED'), so there is nothing left to count down.
   */
  updateTrialCountdown() {
    if (!this.orgPlan?.free_tier || !this.orgPlan?.free_tier_end_date) {
      this.showTrialCountdown = false;
      this.daysRemainingInTrial = null;
      return;
    }

    const msPerDay = 24 * 60 * 60 * 1000;
    const end = new Date(this.orgPlan.free_tier_end_date).getTime();
    const daysLeft = Math.max(0, Math.ceil((end - Date.now()) / msPerDay));

    this.daysRemainingInTrial = daysLeft;
    this.trialUrgency =
      daysLeft <= 0 ? 'red' : daysLeft <= 7 ? 'amber' : 'calm';
    this.showTrialCountdown = true;
  }

  playRewardAnimation(reward: number, total: number) {
    this.rewardText = reward > 0 ? `+${reward}` : `${reward}`;

    this.showReward = true;
    this.showCoins = true;
    this.animateWallet = true;

    this.totalCredits = total;

    setTimeout(() => {
      this.showReward = false;
    }, 1800);

    setTimeout(() => {
      this.showCoins = false;
      this.animateWallet = false;
    }, 2200);
  }

  goToNotifications() {
    this.router.navigate(['/notifications']);
  }

  goToActivity() {
    this.router.navigate(['/billings/activity']);
  }

  goToManage() {
    this.router.navigate(['/billings/manage']);
  }

  toggleTheme() {
    this.isLight = !this.isLight;

    const body = document.body;

    if (this.isLight) {
      body.classList.add('light-theme');
      localStorage.setItem('theme', 'light');
    } else {
      body.classList.remove('light-theme');
      localStorage.setItem('theme', 'dark');
    }
  }

  toDigits(value: number): number[] {
    return value.toString().split('').map(Number);
  }

  /**
   * The organization a candidate applied through, or null for a candidate
   * who registered on their own. Written at login from the root of the
   * response (`user.organization` is null in both cases, so it can't be
   * used for this).
   */
  private storedOrg(): any {
    try {
      const raw = localStorage.getItem('org');
      if (!raw || raw === 'null' || raw === 'undefined') return null;
      const org = JSON.parse(raw);
      return org && org.id ? org : null;
    } catch {
      return null;
    }
  }

  /** A CND signed in against an organization's job post. */
  get isOrgScopedCandidate(): boolean {
    return this.role === 'cnd' && !!this.storedOrg();
  }

  generateMenu() {
    // Org-scoped candidates read from their own menu list rather than the
    // full candidate one.
    const menuKey = this.isOrgScopedCandidate ? 'cnd_org' : this.role;
    const allowedMenus = this.menuConfig[menuKey] || [];

    this.visibleMenus = allowedMenus
      .map((key: string) => this.allMenus[key])
      .filter((menu: any) => !!menu);
  }

  animateCredits(oldValue: number, newValue: number) {
    let step = oldValue;

    const interval = setInterval(() => {
      if (step === newValue) {
        clearInterval(interval);
        return;
      }

      step += newValue > oldValue ? 1 : -1;

      this.animatedDigits = this.toDigits(step);
    }, 20);
  }

  loadCredits() {
    this.creditService.getCredits().subscribe((res: any) => {
      this.credits = res[0]; // API array return kar rahi hai
    });
  }

  isMenuOpen: boolean = false;

  // Method to toggle the menu visibility
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  // Method to close the menu when any item is clicked
  closeMenu() {
    this.isMenuOpen = false;
  }

  private updateDateTime() {
    this.currentDateTime = new Date();
  }

  toggleFullScreen(): void {
    if (this.isFullScreen) {
      this.exitFullScreen();
    } else {
      this.requestFullScreen();
    }
  }

  requestFullScreen(): void {
    const docEl = document.documentElement;

    if (docEl.requestFullscreen) {
      docEl.requestFullscreen();
    } else {
      console.error('Fullscreen API is not supported');
    }

    this.isFullScreen = true;
  }

  exitFullScreen(): void {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else {
      console.error('Fullscreen API is not supported');
    }

    this.isFullScreen = false;
  }

  handleFullScreenChange(): void {
    this.isFullScreen = !!document.fullscreenElement;
  }

  setTheme() {
    var theme = this.isDarkTheme
      ? 'bootstrap4-dark-blue'
      : 'bootstrap4-light-blue';
    this.themeService.toggleAppTheme(theme);
  }

  setThemeButtonProperties(): void {
    if (this.isDarkTheme) {
      this.themeButtonIcon = 'pi pi-sun';
    } else {
      this.themeButtonIcon = 'pi pi-moon';
    }
  }

  /** The roles whose profile lives on /employee-profile. */
  private readonly employeeProfileRoles = [
    'org_admin',
    'hr_head',
    'recruiter',
    'tl',
    'reporting_manager',
  ];

  get hasEmployeeProfile(): boolean {
    return this.employeeProfileRoles.includes((this.role || '').toLowerCase());
  }

  goToOrganizationTree() {
    this.router.navigate(['/employee-profile/tree']);
  }

  updateProfile() {
    if (this.hasEmployeeProfile) {
      this.router.navigate(['/employee-profile']);
      return;
    }

    this.router.navigate(['/candidate-profile']);
  }

  resetPassword() {
    this.router.navigate(['/auth-reset-password']);
  }

  logout() {
    this.authentication.logout(true);
  }

  menuItems = [
    {
      label: 'Profile',
      icon: 'pi pi-user',
      routerLink: '/candidate-profile',
    },
    {
      label: 'Resume Builder',
      icon: 'pi pi-file',
      routerLink: '/resume-builder',
    },
    { separator: true },
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.logout(),
    },
  ];
}
